const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");

const form = require('../../deploynaut/js/Form.jsx');
const Modal = require('../../deploynaut/js/Modal.jsx');
const VerifiedDomainsTable = require('./VerifiedDomainsTable.jsx');
const RemoveModal = require('./RemoveLetsEncryptDomainForm.jsx');

const LetsEncrypt = createReactClass({
	getInitialState: function() {
		return {
			editing: false,
			message: { type: 'success', body: '' }
		};
	},

	afterModalClose(data) {
		let newState = {
			removingDomain: false
		};

		this.setState(newState);
		this.props.afterSuccess(data);
	},

	cancelHandler: function(event) {
		if(event) {
			event.preventDefault();
		}
		this.setState({
			removingDomain: false,
		});
	},

	getModal: function (form, title) {
		if(!form) {
			return null;
		}
		return (
			<Modal
				closeHandler={this.cancelHandler}
				title={title}
			>
				{form}
			</Modal>
		);
	},

	showRemoveModal: function(data) {
		this.setState({
			removingDomain: data,
		});
	},

	render: function() {
		let table;
		if (this.props.model.LetsEncryptDomains.length) {
			table = (
				<VerifiedDomainsTable
					domains={this.props.model.LetsEncryptDomains}
					edit={this.startEditing}
					onDelete={this.showRemoveModal}
					allowDelete={this.props.model.CanEditLetsEncryptDomains}
				/>
			)
		}

		let removeModal;
		if (this.state.removingDomain) {
			removeModal =
				this.getModal((
					<RemoveModal
						actionURL={this.props.model.RemoveLetsEncryptDomainURL}
						afterSuccess={this.afterModalClose}
						cancelHandler={this.cancelHandler}
						model={this.props.model}
						domain={this.state.removingDomain}
					/>
				), "Remove Let's Encrypt domain");
		}

		let addForm;
		if (this.props.model.CanEditLetsEncryptDomains) {
			addForm = (
				<form.Form
					buttonTitle="Add domain"
					buttonSubmittingTitle="Saving..."
					url={this.props.model.AddLetsEncryptDomainURL}
					securityID={this.props.model.SecurityID}
					afterSuccess={this.props.afterSuccess}
					cancelButton={<button className="btn btn-link" onClick={this.props.cancelHandler}>Cancel</button>}
				>
					<div className="form-group">
						<label htmlFor="Domains">Domains to add</label>
						<form.Textarea
							name="Domains"
							required
							rows="6"
							validationError="Please enter at least one domain name"
							placeholder="Place each domain name on its own line, for example:
test.com
subdomain.test.com
test.net
test.org"
						/>
					</div>
					<div className="checkbox">
						<label htmlFor="IncludeWWW"><form.Checkbox name="IncludeWWW" value={true} label="Include a 'www' subdomain for each domain" /></label>
					</div>
				</form.Form>
			);
		}

		return (
			<div className="lets-encrypt">
				<p>
					You'll need to add a verification CNAME record to your DNS provider for each domain your certificate
					needs to cover. Once all domains are verified your new certificate will be provisioned to your environment.
					This process may take up to 12 hours.
				</p>

				{table}
				{removeModal}
				{addForm}
			</div>
		);
	}
});

module.exports = LetsEncrypt;
